<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- :include="cachedViews" -->
       <router-view :key="key" v-if="$route.meta.noCache"/>
      <keep-alive>
        <router-view :key="key" v-if="!$route.meta.noCache"/>
      </keep-alive>
    </transition>
    <template v-if="account == 'ds'">
      <div v-if="$store.state.settings.showFooter" id="el-main-footer">
        <span v-html="$store.state.settings.footerTxt" />
        <span> ⋅ </span>
        <a href="https://www.beian.miit.gov.cn" target="_blank">{{ $store.state.settings.caseNumber }}</a>
      </div>
    </template>
  </section>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'AppMain',
  data() {
    return {
      account: null
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  created() {
    this.account = Cookies.get('account')
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: 115px;
  #el-main-footer{
    width: 100%;
  }
}

.fixed-header+.app-main {
  padding-top: 115px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 15px);
  }

  .fixed-header+.app-main {
    padding-top: 115px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
